export default function intRange(start: number, end: number): number[] {
  const diff = end - start;
  const mul = diff > 0 ? 1 : -1;
  const absdiff = Math.abs(diff);

  const result = new Array<number>(absdiff);

  for (let i = 0; i < absdiff; i++) {
    result[i] = start + mul * i;
  }

  return result;
}
